































import Vue from 'vue'
import Notification from 'element-ui/packages/notification/src/main.vue'

/**
 * This component extends ElNotification with slight differences like the icon, no title and not closable by user
 */
export default Vue.extend({
  name: 'DdNotification',

  extends: Notification,
})
